import { FiGithub, FiLinkedin } from 'react-icons/fi';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Skills', href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid rgba(255,255,255,0.05)', padding: '3.5rem 0 2rem' }}>
      <div className="section-container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '2.5rem', marginBottom: '2.5rem' }}>
          <div>
            <a href="#home" style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '1.05rem', fontWeight: 700, background: 'linear-gradient(135deg,#3b82f6,#8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', textDecoration: 'none', display: 'block', marginBottom: '0.6rem' }}>
              aryan.dev
            </a>
            <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.82rem', color: '#475569', lineHeight: 1.7, maxWidth: 220 }}>
              Full Stack Developer actively seeking graduate and junior developer roles in Sydney.
            </p>
          </div>

          <div>
            <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.66rem', color: '#6366f1', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>Navigation</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {navLinks.map(link => (
                <a key={link.href} href={link.href} style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.85rem', color: '#475569', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#f0f6ff')} onMouseLeave={e => (e.currentTarget.style.color = '#475569')}>
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.66rem', color: '#6366f1', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>Contact</p>
            <a href="mailto:aryandevpandey22@gmail.com" style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.82rem', color: '#475569', textDecoration: 'none', display: 'block', marginBottom: '1.25rem', transition: 'color 0.2s' }}
              onMouseEnter={e => (e.currentTarget.style.color = '#f0f6ff')} onMouseLeave={e => (e.currentTarget.style.color = '#475569')}>
              aryandevpandey22@gmail.com
            </a>
            <div style={{ display: 'flex', gap: '0.7rem' }}>
              {[{ Icon: FiGithub, href: 'https://github.com/arbhram', label: 'GitHub' }, { Icon: FiLinkedin, href: 'https://www.linkedin.com/in/aryan-dev-pandey-03ab62255/', label: 'LinkedIn' }].map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                  style={{ width: 36, height: 36, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', fontSize: '0.95rem', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.12)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.3)'; e.currentTarget.style.color = '#f0f6ff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = '#475569'; }}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '1.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem' }}>
          <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.68rem', color: '#2d3748' }}>
            © 2025 Aryan Dev Pandey. Built with React, Three.js & Tailwind CSS.
          </p>
          <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.68rem', color: '#2d3748' }}>
            Designed & developed in Sydney 🇦🇺
          </p>
        </div>
      </div>
    </footer>
  );
}
